<template>
    <div id="mobile-controller-component">
        <a href="#" id="btn-jump" ref="btn-jump" v-on:touchstart="jump">
            <img :src="$url + 'img/pular_bt.png'">
        </a>
    </div>
</template>
<script>
    //import * as BABYLON from 'babylonjs';
    import * as GUI from 'babylonjs-gui';
    
    export default {
        name: "MobileControllerComponent",
        data() {
            return {
                adt: GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI"),
                xAddPos: 0,
                yAddPos: 0,
                xAddRot: 0,
                yAddRot: 0,
                sideJoystickOffset: 20,
                bottomJoystickOffset: -20,
                translateTransform: null,

                //
                //
                mov_type       : null,
                left           : false,
                right          : false,
                back           : false,
                walk           : false,
            }
        },
       
        methods: {
            jump(e) {
                this.$parent.jumpMobile();
                e.preventDefault();
            },


            //----- move -----//
            down() {
                console.log('down');
            },
            up() {
                //if (this.walk) {
                    console.log('up');
                    this.$parent.cc.walk(false);
                    this.$parent.cc.turnLeft(false);
                    this.$parent.cc.turnRight(false);
                    this.$parent.cc.idle(true);
                    this.walk = false;
                    this.left = false;
                    this.right = false;
                    this.back = false;
                //}
            },
            move(x_, y_) {

                console.log('x_, y_ ->', x_, y_);


                /*if (!this.walk) {
                    this.walk = true;
                    this.$parent.cc.walk(true);
                }*/

                if (x_ < -30){
                    this.left = true;

                    if (this.walk){
                        this.walk = false;
                        this.$parent.cc.walk(false);
                    }
                    if (this.right)
                        this.$parent.cc.turnRight(false);

                    this.$parent.cc.turnLeft(true);
                    this.right = false;
                } else if (x_ > 30) {
                    this.right = true;

                    if (this.walk) {
                        this.walk = false;
                        this.$parent.cc.walk(false);
                    }
                    if (this.left)
                        this.$parent.cc.turnLeft(false);

                    this.$parent.cc.turnRight(true);
                    this.left = false;
                } else if ((x_ > -30) && (x_ < 30)) {
                    if (this.walk) {
                        this.walk = false;
                        this.$parent.cc.walk(false);
                    }
                    if (this.left)
                        this.$parent.cc.turnLeft(false);
                    if (this.right)
                        this.$parent.cc.turnRight(false);

                    this.left = false;
                    this.right = false;

                    //if (!this.back) {
                        //this.walk = true;
                        //this.$parent.cc.walk(true);
                    //}
                    
                }

                //front, back
                if (y_ > 30) {
                    if (!this.walk) {
                        this.walk = true;
                        if (this.back)
                            this.$parent.cc.walkBack(false);

                        this.$parent.cc.walk(true);
                        this.back = false;
                        this.walk = true;
                                    
                    }
                } else if (y_ < -30) {
                    if (!this.back) {
                        console.log('back');
                        this.back = true;
                        if (this.walk) {
                            this.walk = false;
                            this.$parent.cc.walk(false);
                        }
                        this.$parent.cc.walkBack(true);   
                    }
                }
                else if ((y_ > -30) && (y_ < 30))
                {
                    if (this.back) {
                        this.back = false;
                        this.$parent.cc.walkBack(false);
                    }
                    if (this.walk) {
                        this.walk = false;
                        this.$parent.cc.walk(false);
                    }
                }
                //
                




                /*
                if (this.left_joy_stick && this.left_joy_stick.pressed) {
                    this.mov_type = this.left_joy_stick;
                } else if (this.right_joy_stick && this.right_joy_stick.pressed) {
                    this.mov_type = this.right_joy_stick;
                } else {
                    this.mov_type = null;
                    try {
                        if (this.walk) {

                            console.log('destruct');
                            this.cc.walk(false);
                            this.cc.turnLeft(false);
                            this.cc.turnRight(false);
                            this.cc.idle(true);
                            this.walk = false;
                            this.left = false;
                            this.right = false;
                            this.back = false;

                            //this.cc.stop();
                        }
                                       
                     } catch(e) { console.log(e); }
                }

                if (this.mov_type) {
                    let moveX = this.mov_type.deltaPosition.x * (this.engine.getDeltaTime() / 1000) * movespeed;
                    let moveZ = this.mov_type.deltaPosition.y * (this.engine.getDeltaTime() / 1000) * movespeed;

                        

                    if (!this.walk) {
                        this.walk = true;
                        this.cc.walk(true);
                    }
                    console.log(moveX);
                    if (moveX < -0.20) {
                        if (!this.left) {
                            this.left = true;
                            console.log('left');
                                   
                            if (this.right)
                                 this.cc.turnRight(false);

                            this.cc.turnLeft(true);
                            this.right = false;    
                        }    
                    } else if (moveX > 0.20) {
                        if (!this.right) {
                            this.right = true;
                            console.log('right');
                                    
                            if (this.left)
                                this.cc.turnLeft(false);

                            this.cc.turnRight(true);
                            this.left = false;
                                    
                        }
                                
                    } else if ((moveX > -0.23) && (moveX < 0.23)) {
                        //console.log('front');
                        if (this.left)
                            this.cc.turnLeft(false);
                        if (this.right)
                            this.cc.turnRight(false);

                            this.left = false;
                            this.right = false;
                    }

                    //front, back
                    if (moveZ > 0) {
                        if (!this.front) {
                            this.front = true;
                            console.log('front');
                            if (this.back)
                                    this.cc.walkBack(false);

                            this.cc.walk(true);
                            this.back = false;
                                    
                        }
                    } else if (moveZ < 0) {
                        if (!this.back) {
                            this.back = true;
                            console.log('back');
                            if (this.front)
                                this.cc.walk(false);

                            this.cc.walkBack(true);
                            this.front = false;
                                    
                        }
                    }
                }*/
            },
            //----- \move\ -----//




            makeThumbArea(name, thickness, color, background, curves) {
                name, thickness, color, background, curves;


                let rect = new GUI.Ellipse();
                rect.name = name;
                rect.thickness = thickness;
                rect.color = color;
                rect.background = background;
                rect.paddingLeft = "0px";
                rect.paddingRight = "0px";
                rect.paddingTop = "0px";
                rect.paddingBottom = "0px";
                return rect;
            },


            //start
            start() {
                
                let root_ = this;
                root_;
                //BABYLON;


                let leftThumbContainer = this.makeThumbArea("leftThumb", 2, "blue", null);
                leftThumbContainer.height = "150px";
                leftThumbContainer.width = "150px";
                leftThumbContainer.isPointerBlocker = true;
                leftThumbContainer.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
                leftThumbContainer.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
                leftThumbContainer.alpha = 0.4;
                leftThumbContainer.left = this.sideJoystickOffset;
                leftThumbContainer.top = this.bottomJoystickOffset;
        
                let leftInnerThumbContainer = this.makeThumbArea("leftInnterThumb", 4, "blue", null);
                leftInnerThumbContainer.height = "80px";
                leftInnerThumbContainer.width = "80px";
                leftInnerThumbContainer.isPointerBlocker = true;
                leftInnerThumbContainer.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
                leftInnerThumbContainer.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        
        
                let leftPuck = this.makeThumbArea("leftPuck", 0, "blue", "blue");
                leftPuck.height = "40px";
                leftPuck.width = "40px";
                leftPuck.isPointerBlocker = true;
                leftPuck.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
                leftPuck.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        
        
                leftThumbContainer.onPointerDownObservable.add(function(coordinates) {
                    leftPuck.isVisible = true;
                    leftPuck.floatLeft = coordinates.x - (leftThumbContainer._currentMeasure.width*.5) - root_.sideJoystickOffset;
                    leftPuck.left = leftPuck.floatLeft;
                    leftPuck.floatTop = root_.adt._canvas.height - coordinates.y - (leftThumbContainer._currentMeasure.height*.5) + root_.bottomJoystickOffset;
                    leftPuck.top = leftPuck.floatTop*-1;
                    leftPuck.isDown = true;
                    leftThumbContainer.alpha = 0.9;

                    root_.down();
                });
        
                leftThumbContainer.onPointerUpObservable.add(function(coordinates) {
                    coordinates;

                    root_.xAddPos = 0;
                    root_.yAddPos = 0;
                    leftPuck.isDown = false;
                    leftPuck.isVisible = false;
                    leftThumbContainer.alpha = 0.4;

                    root_.up();
                });

                leftThumbContainer.onPointerMoveObservable.add(function(coordinates) {
                    if (leftPuck.isDown) {
                        root_.xAddPos = coordinates.x-(leftThumbContainer._currentMeasure.width*.5)-root_.sideJoystickOffset;
                        root_.yAddPos = root_.adt._canvas.height - coordinates.y-(leftThumbContainer._currentMeasure.height*.5) + root_.bottomJoystickOffset;
                        leftPuck.floatLeft = root_.xAddPos;
                        leftPuck.floatTop = root_.yAddPos*-1;
                        leftPuck.left = leftPuck.floatLeft;
                        leftPuck.top = leftPuck.floatTop;

                        root_.move(root_.xAddPos, root_.yAddPos);
                    }
              });

                this.adt.addControl(leftThumbContainer);
                leftThumbContainer.addControl(leftInnerThumbContainer);
                leftThumbContainer.addControl(leftPuck);
                leftPuck.isVisible = false;
            }
        },
        mounted() {
            this.start();
        }
    }
</script>
<style>
    html, #btn-jump
    {
        user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
    }
</style>
<style scoped>
    #mobile-controller-component {
        
    }
    #btn-jump {
        bottom: 0;
        right: 10px;
        opacity: 1;
        position: absolute;
    }
</style>